import { COLORS } from '../../constants/theme';
import type { QuickIntelFeedback as FeedbackType } from '../../types/attackCalculator';

interface QuickIntelFeedbackProps {
  feedback: FeedbackType | null;
}

export function QuickIntelFeedback({ feedback }: QuickIntelFeedbackProps) {
  if (!feedback) return null;

  const isSuccess = feedback.type === 'success';

  return (
    <div
      className="px-3 py-2 rounded text-sm"
      style={
        isSuccess
          ? { background: COLORS.successBg, border: `1px solid ${COLORS.successBorder}`, color: COLORS.successText }
          : { background: COLORS.errorBg, border: `1px solid ${COLORS.errorBorder}`, color: COLORS.errorText }
      }
    >
      {feedback.message}
    </div>
  );
}
